import React from 'react';
import { Route, Switch } from "react-router-dom";
import Home from "./Home/MainPage";
import Program from "./Program/MainPage";
import TafsirMain from "./Tafsir/TafsirMain";
import TajweedMain from "./Tajweed/TajweedMain";
import Trivia from "./Trivia/MainPage";
import Memorize from "./Memorize/MainPage";
import Contact from "./Contact/MainPage";
import Admin from "./Admin/MainPage";

const Routes = () => (
  <Switch>
    <Route exact path="/" component={Home}/>
    <Route path="/program" component={Program}/>
    <Route path="/tafsir" component={TafsirMain}/>
    <Route path="/trivia" component={Trivia}/>
    <Route path="/tajweed" component={TajweedMain}/>
    <Route path="/hifth" component={Memorize}/>
    <Route path="/contact" component={Contact}/>
    <Route exact path="/admin/portal/a8907345kj" component={Admin}/>
    <Route component={Home}/>
  </Switch>
)
export default Routes;